/* eslint-disable react-hooks/exhaustive-deps */
import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { getBondDeptsClientDetailExcel, getBondDeptsClientDetailList } from "../../apis/bond-debts";
import useForm from "../../hooks/useForm";
import { calcPreBalance } from "../../utils/bond-debt";
import { getParams } from "../../utils/params";
import { transformComma } from "../../utils/validator/comma";
import Filters from "../Filters";
import { ControlTable } from "../Table";
import { ModalHeader } from "../Modal";
import Button from "../Button";
import { downExcelFile } from "../../utils/download";
import { viewLoading } from "../../utils/loading";

const BondDebt = ({ filterParams, data, type }) => {
  const [fields, setFields] = useState([]);

  const [preBalance, setPreBalance] = useState(0);
  useEffect(() => {
    setFields([
      { title: "거래일자", key: "trDate" },
      {
        title: type === "invoice" ? "거래명세서 매출" : "발행매출",
        key: type === "invoice" ? "salesAmt" : "issuedSalesAmt",
        type: "comma",
      },
      {
        title: type === "invoice" ? "거래명세서 매입" : "발행매입",
        key: type === "invoice" ? "purchaseAmt" : "issuedPurchaseAmt",
        type: "comma",
      },
      {
        title: "입금",
        key: "accountInAmt",
        type: "comma",
        className: "color-red-100",
      },
      {
        title: "출금",
        key: "accountOutAmt",
        type: "comma",
        className: "color-purple-100",
      },
      {
        title: "잔액",
        key: "balanceAmt",
        type: "comma",
      },
    ]);
  }, [type]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list,
    setList,
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page,
    setPage,
    limit,
    setLimit,
  } = useForm({
    range: {
      trDate: [filterParams?.range?.trDate[0], filterParams?.range?.trDate[1]],
    },
    page: 0,
    limit: 10,
  });

  useEffect(() => {
    if (submit) {
      submit(form);
      setSubmit(submit);
    }

    if (!isEmpty(data)) {
      setPreBalance(transformComma(calcPreBalance(data, type)));
    }
  }, [data]);

  const submit = (_params) => {
    setIsLoading(true);
    getBondDeptsClientDetailList(data.clientIdx, {
      type,
      // clientIdx: data.clientIdx,
      ...getParams(_params),
    })
      .then((res) => {
        if (!isEmpty(get(res, "data.summaries[0]"))) {
          setPreBalance(transformComma(calcPreBalance(get(res, "data.summaries[0]"), type)));
        }

        setList(res.data.bondDebts);
        setTotal(res.data.totalCount);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filterConfig = [
    {
      label: "조회기간",
      type: "customdatepicker",
      key: "range.trDate",
    },
  ];

  const downloadExcel = () => {
    viewLoading("엑셀파일 다운로드중 입니다.");
    getBondDeptsClientDetailExcel(data.clientIdx, {
      type,
      ...getParams(form),
    }).then((res) => {
      const filename = `[${data?.client?.name}]_${type === "invoice" ? "거래명세서_기준" : "발행내역_기준"}_상세내역(${get(form, "range.trDate[0]", "")}-${get(form, "range.trDate[1]", "")}).xlsx`;
      downExcelFile(res, filename);
    }).finally(() => viewLoading(false));
  };
  return (
    <>
      <ModalHeader>
        {get(data, "client.name")}의 채권채무 상세 내역
      </ModalHeader>
      <div className="header-button-wrap">
        <Button
          className="print-button print-out"
          label="엑셀 다운로드"
          onClick={() => downloadExcel()}
          disabled={isLoading || isEmpty(list)}
        />
      </div>
      <Filters
        isLoading={isLoading}
        filters={filterConfig}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        title={
          <p>
            이월{" "}
            <span
              style={{
                fontSize: "17px",
                fontWeight: 800,
                margin: "0 5px",
              }}
            >
              {preBalance}
            </span>
            원
          </p>
        }
        isLoading={isLoading}
        fields={fields}
        list={list}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        submit={handleSubmit}
      />
    </>
  );
};

export default BondDebt;
